export const environment = {
  production: true,
  issuer: 'https://pandarg.okta.com/oauth2/default',
  clientId:'0oaizyxndvQxHxBdz4x7',
  serverUrl: "https://appprgpayrolladjustmentapi.azurewebsites.net",
  redirectUri: `${window.location.origin}/login/callback`,
  impersonation: false
};
